const styles = () => ({
  stepContent: {
    display: 'flex',
    margin: 20,
    overflow: 'hidden',
    background: 'rgb(255, 255, 255)',
    borderRadius: '8px 8px 8px 8px',
    border: '1px solid rgb(225, 233, 240)',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 20px',
    marginBottom: '16px',
  },

  skipStep: {
    color: '#7b8b99',
    fontWeight: '500',
    fontSize: '15px',
  },

  tabs: {
    borderRight: '1px solid rgb(225, 233, 240)',
    background: '#fafbfc',
  },

  tabsIndicator: { display: 'none' },

  tabsFlexContainer: {
    flexDirection: 'column',
  },

  tab: {
    borderBottom: '1px solid rgb(225, 233, 240)',
    minHeight: 'unset',
    height: '72px',
    paddingTop: 0,

    '&:focus': {
      outline: 'none',
    },
  },

  tabWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '18px',
  },

  tabLabelContainer: {
    textAlign: 'left',
    padding: 0,
  },

  tabLogo: {
    marginRight: '12px',
    width: '24px',
    height: '24px',
  },

  tabDisconnectedLabelLine: {
    color: '#7b8b99',
    fontStyle: 'italic',
  },

  tabLabelPrimary: {
    display: 'flex',
    alignItems: 'center',
    color: '#27282a',
    lineHeight: '18px',

    '& > svg': {
      marginLeft: '5px',
    },
  },

  tabLabelSecondary: {
    display: 'block',
    maxWidth: '190px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#7b8b99',
    fontSize: 12,
    lineHeight: '18px',
  },

  tabSelected: {
    background: '#fff',
  },

  servicePanel: {
    flexGrow: 1,
    padding: 40,
  },
});

export default styles;
